import * as React from 'react';
import { InjectedFormProps } from 'redux-form';
import { FaSpinner } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

interface IAMTCancelReasonProps extends InjectedFormProps<any> {
  handleDiscountSelected: (discount) => void;
  discount: any;
  calculating: boolean;
  cancellationReason?: string;
}

export interface IDiscount {
  id: string;
  code: string;
  discount: number;
}

export const CancellationDiscount = ({
                                       handleDiscountSelected,
                                       calculating = false,
                                       discount,
                                     }: IAMTCancelReasonProps) => {

  const hideDiscount = discount.hideDiscount;
  const fullDiscount = discount.isFullDiscount
  const selectedDiscount: IDiscount = discount.selected;
  const previousDiscount = discount.previousDiscount;

  const handleDiscountSelect = () => {
    handleDiscountSelected(selectedDiscount)
  }

  if (!selectedDiscount?.discount) {
    return null;
  }

  if (hideDiscount || selectedDiscount?.discount - previousDiscount <= 0) {
    return null;
  }

  return (
    <>
      <Button
        bsStyle="primary"
        type="button"
        bsSize="small"
        block={true}
        className={'functional-button'}
        onClick={handleDiscountSelect}
        disabled={calculating}>
        {calculating && (
          <FaSpinner className="fa-spin"/>
        )}
        KEEP MY COVER WITH {fullDiscount ? selectedDiscount?.discount : selectedDiscount?.discount - previousDiscount}%
        OFF
      </Button>
    </>
  )
}
